const { define_svg_element,emit_on_all_svg_loaded,emit_on_all_svg_full_loaded } = require('./svg_element.js');

const { define_mailform_element } = require('./mailform_element.js');
const { define_footer_element } = require('./footer_element.js');
const { define_splide_slide_element,emit_on_all_splide_slide_loaded } = require('./splide_slide_element.js');

module.exports.define_svg_element = define_svg_element;
module.exports.emit_on_all_svg_loaded = emit_on_all_svg_loaded;
module.exports.emit_on_all_svg_full_loaded = emit_on_all_svg_full_loaded;
module.exports.define_footer_element = define_footer_element;
module.exports.define_mailform_element = define_mailform_element;
module.exports.define_splide_slide_element = define_splide_slide_element;
module.exports.emit_on_all_splide_slide_loaded = emit_on_all_splide_slide_loaded;